import useFetch from '@/composables/useFetch';
import { PaginationResponse } from '@/model/api';
import { Hentai, HentaiOption, HentaiPaginationRequest } from '@/model/hentai';
import { HttpStatusCode } from 'axios';

export async function getHentaiPagination(query: HentaiPaginationRequest) {
	const res = await useFetch<PaginationResponse<Hentai>>({
		method: 'GET',
		url: '/hentai',
		params: query,
		signalUUID: `GET_HENTAI_PAGINATION`
	});
	return res.data;
}

export async function getHentai(hentaiUUID: string) {
	return await useFetch<Hentai>({
		method: 'GET',
		url: '/hentai/' + hentaiUUID
	});
}

export async function createHentai(data: Hentai) {
	return await useFetch<{ hentaiUUID: string }>({
		method: 'POST',
		url: '/hentai',
		data
	});
}

export async function updateHentai(data: Hentai) {
	return await useFetch({
		method: 'PATCH',
		url: '/hentai/' + data.hentaiUUID,
		data
	});
}

export async function favoriteHentai(hentaiUUID: string, isFavorite: boolean) {
	return await useFetch({
		method: 'PATCH',
		url: `/hentai/${hentaiUUID}/favorite`,
		data: { isFavorite }
	});
}

export async function deleteHentai(hentaiUUID: string) {
	return await useFetch({
		method: 'DELETE',
		url: '/hentai/' + hentaiUUID
	});
}

export async function getHentaiOptions(): Promise<HentaiOption> {
	const res = await useFetch<HentaiOption>({
		method: 'GET',
		url: '/hentai/option'
	});
	if (res.status === HttpStatusCode.Ok && res.data) {
		return res.data;
	}
	return { categories: [] };
}

export async function createHentaiEpisode(hentaiUUID: string, episode: string, link: string) {
	return await useFetch({
		method: 'POST',
		url: `/hentai/${hentaiUUID}/${episode}`,
		data: { link }
	});
}

export async function deleteHentaiEpisode(hentaiUUID: string, episode: string) {
	return await useFetch({
		method: 'DELETE',
		url: `/hentai/${hentaiUUID}/${episode}`
	});
}

export async function updateNoteHentai(hentaiUUID: string, note: string) {
	return await useFetch({
		method: 'PATCH',
		url: `/hentai/${hentaiUUID}/note`,
		data: { note }
	});
}
